import { ChangeDetectionStrategy, Component, OnChanges, Renderer2, SimpleChanges, inject, input } from '@angular/core';

@Component({
    selector: 'oiv-viewer-overlay',
    templateUrl: './overlay.component.html',
    styleUrl: './overlay.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [],
})
export class OverlayComponent implements OnChanges {
    #renderer = inject(Renderer2);

    isVisible = input<boolean>(false);

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['isVisible'].currentValue) {
            this.#renderer.addClass(document.body, 'overlay-open');
        } else {
            this.#renderer.removeClass(document.body, 'overlay-open');
        }
    }
}
